import { render, staticRenderFns } from "./config.view.vue?vue&type=template&id=b185232e&scoped=true"
import script from "./config.view.vue?vue&type=script&lang=js"
export * from "./config.view.vue?vue&type=script&lang=js"
import style0 from "./config.view.vue?vue&type=style&index=0&id=b185232e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b185232e",
  null
  
)

export default component.exports